<template>
  <div class="pl-2 pt-2">
    <div class="flex items-center max-w-sm mb-2">
      <label class="w-3/4" :for="'deposit_difference' + item.id">Differenz</label>
      <input
        :value="deposit_difference"
        @input="updateDepositDifference"
        class="w-1/4 p-0 px-1 text-center"
        type="number"
        :name="'deposit_difference' + item.id"
        id="deposit_difference"
        min="-999"
        max="999"
        placeholder="-">
    </div>
    <div class="text-xs italic mt-2 mb-2">
      Hinweis: Sie können auch negative Werte eingeben (z.B. -1)
    </div>
    <div v-if="!differenceInRange" class="text-red-600 my-3 text-sm mb-2">
      Bitte geben Sie eine Stückzahl zwischen -999 und 999 an.
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositForm',
  props: {
    item: {
      type: Object,
      required: true
    },
    deposit_difference: {
      type: Number,
      require: true
    }
  },

  data: () => ({
    differenceInRange: true,
  }),

  methods: {
    updateDepositDifference(event) {
      this.differenceInRange = true
      let depositDifference = event.target.value

      if (depositDifference > 999) {
        depositDifference = 999
        this.differenceInRange = false
      }

      if (depositDifference < -999) {
        depositDifference = -999
        this.differenceInRange = false
      }

      this.$emit('update:deposit_difference', isNaN(parseInt(depositDifference)) ? null : parseInt(depositDifference))
    },
  }
}
</script>
